import { useEffect, useState } from "react";
import {
  BsFilter,
  BsPlusCircle,
  BsXLg,
  BsChevronLeft,
  BsChevronRight,
  BsTrash,
  BsSearch,
  BsFillExclamationCircleFill,
} from "react-icons/bs";
import Loader from "../../components/common/Loader";
import styles from "./UserManagement.module.scss";
import { Button, Modal, Table } from "reactstrap";
import NodataImage from "../../resources/images/no-data.svg";
import AddUserForm from "./components/AddUserForm";
import UserProfile from "./components/UserProfile";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import { BsFillBarChartFill } from "react-icons/bs";
import useModal from "../../components/Hooks/useModal";
import { User, UserGroup, UserRole } from "../../interfaces/interfaces";
import { UsersRestS } from "../../rest/users-rest-service";
import {
  encryptData,
  getLocalUser,
  getLocalUserId,
  getRandomColor,
} from "../../components/functions/utilities";
import AddGroupForm from "./components/AddGroupForm";
import ViewGroup from "./components/ViewGroup";
import { getTime } from "../../components/functions/utilities";
import usePageTitle from "../../components/Hooks/usePageTitle";
import { CustomTooltip } from "../ReportDetails/Components/ReportTabs/TabsContent/reportDataPiece/tooltip/Tooltip.styled";
import { OverlayTrigger } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import TutorialsTooltip from "../../components/common/tutorialsTooltip/TutorialsTooltip";
import ReactJoyride, {
  ACTIONS,
  CallBackProps,
  EVENTS,
  STATUS,
} from "react-joyride";
import { WorkspaceSteps } from "../../redux/tutorials/stepValues";
import {
  endWorkspaceTour,
  startWorkspaceTour,
  stopWorkspaceTour,
  WorkspaceStepValues,
} from "../../redux/tutorials/tutorials.slice";
import { useNavigate, useOutletContext } from "react-router";
import { RestS } from "../../rest/rest-service";
import EditProfileModal from "./components/EditProfileModal";
import NewUserModal from "./components/NewUserModal";
import HeaderTitle from "../../components/common/HeaderTitle";
import { RiStore2Line, RiUserSharedLine } from "react-icons/ri";
import { HiChevronLeft, HiChevronRight, HiOutlineUserGroup } from "react-icons/hi";
import MeritoButton from "../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineEdit } from "react-icons/md";
import AddCustomerModal from "./components/AddCustomer";
import BrandTable from "./components/BrandTable";
import { useSelector } from "react-redux";
import { registerControlPanelRefresh } from "../../redux/controlPanel/controlPanel";
import { useSearchParams } from "react-router-dom";
import { fetchAgencyClients } from "../../redux/agencyConfig/agencyConfigUtil";

const initialPageData = {
  currPage: 1,
  totalRecord: 0,
  pageCount: 10,
  totalPage: 0,
};

export enum TabRole {
  Brand = "Brand",
  Team = "Team",
}

export default function UserManagement() {
  const [isAddUser, setIsAddUser] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User>();
  const [selectedUserGroup, setSelectedUserGroup] = useState<any>();
  const [editProfile, setEditProfile] = useState(false);
  const [currentTab, setCurrentTab] = useState<string>("user");

  const [isAddGroup, setIsAddGroup] = useState(false);
  const [isViewGroup, setIsViewGroup] = useState(false);

  const [userDisplayList, setUserDisplayList] = useState<User[]>([]);
  const [activityStatus, setActivityStatus] = useState<User[]>([]);
  const [userGroupData, setUserGroupData] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sortingData, setSortingData] = useState({ by: "", type: false });
  const [groupSortingData, setGroupSortingData] = useState({
    by: "",
    type: false,
  });
  const [viewAll, setViewAll] = useState<Boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false);
  usePageTitle("Control Panel | Merito");

  let { toggle, visible } = useModal();
  const currentUser = getLocalUser();

  const [pageData, setPageData] = useState<{
    currPage: number;
    totalRecord: number;
    pageCount: number;
    totalPage: number;
  }>(initialPageData);
  const [stepIndex, setStepIndex] = useState(0);
  const { workspaceTourRunState, currentWorkspaceStepValue } = useAppSelector(
    (state) => state.tutorials,
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { toggle: newUserToggle, visible: newUserVisible } = useModal();
  const { toggle: editProfileToggle, visible: editProfileVisible } = useModal();
  const [tab, setTab] = useState<TabRole>(currentUser.role == 'Agency' ? TabRole.Brand : TabRole.Team);
  const [initialTotalCount, setInitialTotalCount] = useState(-1)
  const [showEllipsis, setShowEllipsis] = useState(false)

  const { headerContent, setHeaderContent, resetHeaderContent } =
    useOutletContext<any>();

  const [searchParams, setSearchParams] = useSearchParams();
  const tabName = searchParams.get("tab") as TabRole;
  const popupState = searchParams.get("popup");

  useEffect(() => {
    if (tabName) {
      setTab(tabName);
    }
    if (popupState == "true") {
      // Handle popup state
      setAddCustomerModalOpen(true);
    }
    if (tabName || popupState) {
      setSearchParams(prev => {
        prev.delete("tab");
        prev.delete("popup");
        return prev;
      })
    }
  }, [tabName, popupState]);

  useEffect(() => {
    setHeaderContent(<HeaderTitle isNav={false} headerTitle="Control Panel" />);
    getUserData();
    return () => {
      resetHeaderContent();
    };
  }, []);

  // useEffect(() => {
  // if (currentTab === "user") getUserData();
  // if (currentTab === "group") getUserGroupData();
  // }, [pageData.currPage, pageData.pageCount, currentTab]);

  useEffect(() => {
    getUserData(null, true)
  }, [tab])

  useEffect(() => {
    // Register the refresh callback on mount
    registerControlPanelRefresh(() => getUserData());
  }, [tab]);

  let getUserData = (alteredPageData = null, tabSwitch = false, alterInitialTotalCount = false) => {
    setIsLoading(true);
    const fetchFn =
      tab === TabRole.Brand
        ? UsersRestS.getBrandListControlPanel
        : UsersRestS.getUserListControlPanel;

    const changedPageData = tabSwitch ? initialPageData : alteredPageData ? alteredPageData : pageData

    fetchFn(
      changedPageData.currPage,
      changedPageData.pageCount,
      '',
    )
      .then((res) => {
        let totalPage = Math.ceil(res.total / changedPageData.pageCount);
        setUserDisplayList(res.users);
        setActivityStatus(res.activityStatus);
        if (!alteredPageData) {
          setPageData({ ...pageData, totalRecord: res.total, totalPage, currPage: 1 });
          if (initialTotalCount == -1 || alterInitialTotalCount) {
            setInitialTotalCount(res.total)
          }
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setIsLoading(false);
      });
  };

  let searchUserData = (search?) => {
    setIsLoading(true);
    const fetchFn =
      tab === TabRole.Brand
        ? UsersRestS.getBrandListControlPanel
        : UsersRestS.getUserListControlPanel;

    fetchFn(
      pageData.currPage,
      pageData.pageCount,
      search,
    )
      .then((res) => {
        let totalPage = Math.ceil(res.total / pageData.pageCount);
        setUserDisplayList(res.users);
        setActivityStatus(res.activityStatus);
        setPageData({
          ...pageData,
          totalRecord: res.total,
          totalPage,
          currPage: 1,
        });
        setIsLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setIsLoading(false);
      });
  };

  let getUserGroupData = (search?) => {
    setIsLoading(true);
    UsersRestS.getUserGroupListControlPanel(
      pageData.currPage,
      pageData.pageCount,
      search,
    )
      .then((res) => {
        let totalPage = Math.ceil(res.total / pageData.pageCount);
        setUserGroupData(res.usersGroup);
        setPageData({ ...pageData, totalRecord: res.total, totalPage });
        setIsLoading(false);
      })
      .catch((e) => console.error(e));
  };

  let tabChange = (tabname: string) => {
    if (currentTab != tabname) {
      setViewAll(false);
      setPageData(initialPageData);
      setSearchValue("");
    }
    setCurrentTab(tabname);
  };

  const sorting = (by) => {
    if (by == sortingData.by) {
      let filterData = [];
      if (sortingData.type) {
        filterData = userDisplayList.sort((a, b) =>
          b[by].toLowerCase() < a[by].toLowerCase() ? -1 : 1,
        );
      } else {
        filterData = userDisplayList.sort((a, b) =>
          a[by].toLowerCase() > b[by].toLowerCase() ? 1 : -1,
        );
      }
      setUserDisplayList(filterData);
      setSortingData((prev) => {
        return { by, type: !prev.type };
      });
    } else {
      let filterData = [];
      filterData = userDisplayList.sort((a, b) =>
        b[by].toLowerCase() < a[by].toLowerCase() ? 1 : -1,
      );
      setUserDisplayList(filterData);
      setSortingData((prev) => {
        return { by, type: true };
      });
    }
  };
  const groupSorting = (by) => {
    if (by == groupSortingData.by) {
      let filterData = [];
      if (groupSortingData.type) {
        filterData = userGroupData.sort((a, b) =>
          b[by].toLowerCase() < a[by].toLowerCase() ? -1 : 1,
        );
      } else {
        filterData = userGroupData.sort((a, b) =>
          a[by].toLowerCase() > b[by].toLowerCase() ? 1 : -1,
        );
      }
      setUserGroupData(filterData);
      setGroupSortingData((prev) => {
        return { by, type: !prev.type };
      });
    } else {
      let filterData = [];
      filterData = userGroupData.sort((a, b) =>
        b[by].toLowerCase() < a[by].toLowerCase() ? 1 : -1,
      );
      setUserGroupData(filterData);
      setGroupSortingData((prev) => {
        return { by, type: true };
      });
    }
  };

  const renderName = (name) => {
    let userNameSplit = name.split(" ");
    return `${userNameSplit[0].charAt(0)}`.toUpperCase();
  };

  const deleteConfirm = () => {
    if (currentTab === "user") {
      if (selectedUser.companyId != currentUser.companyId) {
        console.log("going into agency delete");
        // return
        RestS.deleteInvitedUser(selectedUser.id)
          .then((res) => {
            getUserData(null, false, true);
            setShowUserProfile(false);
            dispatch(fetchAgencyClients({}));
          })
          .catch((e) => {
            toast.error("You can't delete this user.", { autoClose: 3000 });
          });
      } else {
        UsersRestS.deleteUser(selectedUser.id)
          .then((res) => {
            getUserData(null, false, true);
            setShowUserProfile(false);
          })
          .catch((e) => {
            toast.error("You can't delete this user.", { autoClose: 3000 });
          });
      }
    } else {
      UsersRestS.deleteUserGroup(selectedUserGroup.id)
        .then((res) => {
          getUserGroupData();
          setIsViewGroup(false);
        })
        .catch((e) => console.log(e));
    }
  };

  const changeUserRole = (role, userId) => {
    UsersRestS.changeUserRole(role, userId)
      .then((res) => {
        getUserData();
        if (userId == getLocalUserId()) {
          let user = getLocalUser();
          user = { ...user, role };
          localStorage.setItem("user", encryptData(JSON.stringify(user)));
          navigate("/");
          window.location.reload();
        }
      })
      .catch((e) => console.log(e));
  };

  const RenderTooltip = (props, text: string) => {
    return <CustomTooltip {...props}>{text}</CustomTooltip>;
  };

  const handleJoyRideCallback = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    // console.log(action, index, type);
    switch (currentWorkspaceStepValue) {
      case WorkspaceStepValues.addNewUser:
        handleAddUserTutorials(data);
        break;
      case WorkspaceStepValues.addNewGroup:
        handleAddGroupTutorials(data);
        break;
      default:
        break;
    }
  };

  const handleAddGroupTutorials = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    // console.log(data, currentTab);
    const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

    if (action === ACTIONS.CLOSE && workspaceTourRunState) {
      dispatch(endWorkspaceTour());
      if (index > 1) {
        setIsAddGroup(false);
      }
      setStepIndex(0);
      return;
    }
    if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
      //stop tour
      // console.log('stopping tour');
      dispatch(endWorkspaceTour());
      if (index > 1) {
        setIsAddGroup(false);
      }
      setStepIndex(0);
      return;
    } else if (
      ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)
    ) {
      if (index == 0 && action == ACTIONS.NEXT) {
        if (currentTab !== "group") {
          tabChange("group");
        }
        setStepIndex(nextStepIndex);
      } else if (index == 1 && action == ACTIONS.NEXT) {
        dispatch(stopWorkspaceTour());
        setStepIndex(nextStepIndex);
        if (currentTab !== "group") {
          tabChange("group");
        }
        setIsAddGroup(true);
        setTimeout(() => {
          dispatch(startWorkspaceTour());
        }, 100);
      } else if (index == 2 && action == ACTIONS.PREV) {
        setIsAddGroup(false);
        setStepIndex(nextStepIndex);
      } else {
        setStepIndex(nextStepIndex);
        return;
      }
    }
  };

  const handleAddUserTutorials = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    // console.log(data);
    const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
    if (action === ACTIONS.CLOSE && workspaceTourRunState) {
      dispatch(endWorkspaceTour());
      if (index > 0) {
        setIsAddUser(false);
      }
      setStepIndex(0);
      return;
    }
    if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
      //stop tour
      // console.log('stopping tour');
      dispatch(endWorkspaceTour());
      if (index > 0) {
        setIsAddUser(false);
      }
      setStepIndex(0);
      return;
    } else if (
      ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)
    ) {
      if (index == 0 && action == ACTIONS.NEXT) {
        if (currentTab !== "user") {
          tabChange("user");
        }
        setStepIndex(nextStepIndex);
      } else if (index == 1 && action == ACTIONS.NEXT) {
        dispatch(stopWorkspaceTour());
        setStepIndex(nextStepIndex);
        if (currentTab !== "user") {
          tabChange("user");
        }
        setIsAddUser(true);
        setTimeout(() => {
          dispatch(startWorkspaceTour());
        }, 100);
      } else if (index == 2 && action == ACTIONS.PREV) {
        setIsAddUser(false);
        setStepIndex(nextStepIndex);
      } else {
        setStepIndex(nextStepIndex);
        return;
      }
    }
  };

  return (
    <>
      <ReactJoyride
        floaterProps={{
          hideArrow: true,
          disableAnimation: true,
          styles: { wrapper: { zIndex: 102 } },
        }}
        tooltipComponent={TutorialsTooltip}
        continuous
        run={workspaceTourRunState}
        steps={
          currentWorkspaceStepValue
            ? WorkspaceSteps[currentWorkspaceStepValue]
            : []
        }
        callback={handleJoyRideCallback}
        styles={{
          options: {
            zIndex: 2000,
          },
        }}
        disableScrolling={true}
        stepIndex={stepIndex}
        scrollOffset={20}
      />
      {
        <div className={styles.rootContainer}>
          {/* <div className="row"> */}
          {/* <div className="col-12 col-md-8 col-lg-9"> */}
          {/* <div className={styles.tabs}> */}
          {/* <Button
                  onClick={() => {
                    tabChange("user");
                    setIsAddGroup(false);
                    setIsViewGroup(false);
                  }}
                  className={`${styles.tab} ${currentTab === "user" && styles.active
                    } demo_add_user_tab`}
                >
                  Users
                </Button> */}
          {/* <Button
                  onClick={() => {
                    tabChange('group');
                    setIsAddUser(false);
                    setShowUserProfile(false);
                    setEditProfile(false);
                  }}
                  className={`${styles.tab} ${currentTab === 'group' && styles.active} demo_add_group_tab`}>
                  Group
                </Button> */}
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}
          <div className={styles.userTableBlock}>
            <div className={styles.header}>
              <h1>Manage Users</h1>
              <div className={styles.tabs}>
                {
                  currentUser?.role == "Agency" ?
                    <div className={`${styles.items} ${tab == TabRole.Brand ? styles.active : ''}`} onClick={() => setTab(TabRole.Brand)}>
                      <RiStore2Line />
                      <p>Brands</p>
                      {
                        showEllipsis ?
                          <div className={styles.ellipsis}></div> : null
                      }
                    </div> : null
                }
                <div className={`${styles.items} ${tab == TabRole.Team ? styles.active : ''}`} onClick={() => setTab(TabRole.Team)}>
                  <HiOutlineUserGroup />
                  <p>Team</p>
                </div>
              </div>
            </div>
            {
              // isLoading ?
              //   <div className={styles.userManagementTable}>
              //     <div className={styles.listBlock}>
              //     </div>
              //   </div>
              //   :
              tab == TabRole.Brand && !userDisplayList.length && initialTotalCount == 0 ?
                <div className={styles.userManagementTable}>
                  <div className={styles.listBlock}>
                    <div className={styles.brandColdState}>
                      <div className={styles.icon}>
                        <RiStore2Line />
                      </div>
                      <h1>Invite Your Brands</h1>
                      <p>Connect their channels and start tracking instantly.</p>
                      <MeritoButton
                        type='primary-1'
                        size='md'
                        btnText='Invite Brand'
                        icon={<RiUserSharedLine />}
                        onClick={() => { setAddCustomerModalOpen(true) }}
                      />
                    </div>
                  </div>
                </div>
                :
                <div className={styles.userManagementTable}>
                  <div className={styles.listBlock}>
                    <div className="d-flex justify-content-between py-3">
                      <div className={styles.memberCount}>
                        <h2>{tab}</h2>
                        {
                          userDisplayList.length ?
                            <p>{userDisplayList.length}</p> : null
                        }
                      </div>
                      <div className={styles.rightContainer}>
                        <div className={styles.reportTableSearchBar}>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={(props) => RenderTooltip(props, "Search")}
                          >
                            <BsSearch />
                          </OverlayTrigger>
                          <input
                            placeholder="Search name"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                              if (currentTab == "user") {
                                searchUserData(e.target.value);
                              } else {
                                getUserGroupData(e.target.value);
                              }
                            }}
                            maxLength={30}
                          />
                        </div>
                        {
                          tab === TabRole.Brand ?
                            <MeritoButton
                              type="primary-1"
                              size="md"
                              btnText={'Invite Brand'}
                              onClick={() => setAddCustomerModalOpen(true)}
                              icon={<RiUserSharedLine />}
                            /> :
                            <MeritoButton
                              type="primary-1"
                              size="md"
                              btnText={'Add Team Member'}
                              onClick={() => newUserToggle()}
                              icon={<BsPlusCircle />}
                            />
                        }
                      </div>
                    </div>
                    {isLoading ? (
                      <div className="p-5">
                        <Loader color="#c4c4c4" />
                      </div>
                    ) : (
                      <>
                        {currentTab === "user" && (
                          <div className={styles.tableContent}>
                            {
                              tab == TabRole.Team ?
                                <Table borderless>
                                  <thead className={styles.tableHeader}>
                                    <tr>
                                      {/* <th></th> */}
                                      <th colSpan={1}>
                                        Name
                                        <BsFilter
                                          className={`mx-2 j-cursor ${sortingData?.by == "name" &&
                                            sortingData?.type
                                            ? "rotate"
                                            : ""
                                            }`}
                                          onClick={() => {
                                            sorting("name");
                                          }}
                                        />
                                      </th>
                                      {
                                        currentUser?.role != "Agency" ?
                                          <>
                                            <th>
                                              Company Name
                                              <BsFilter
                                                className={`mx-2 j-cursor ${sortingData?.by == "companyName" &&
                                                  sortingData?.type
                                                  ? "rotate"
                                                  : ""
                                                  }`}
                                                onClick={() => {
                                                  sorting("companyName");
                                                }}
                                              />
                                            </th>
                                            {/* <th>
                                              Designation
                                              <BsFilter
                                                className={`mx-2 j-cursor ${sortingData?.by == "designation" &&
                                                  sortingData?.type
                                                  ? "rotate"
                                                  : ""
                                                  }`}
                                                onClick={() => {
                                                  sorting("designation");
                                                }}
                                              />
                                            </th> */}
                                            <th>
                                              Role
                                              <BsFilter
                                                className={`mx-2 j-cursor ${sortingData?.by == "role" &&
                                                  sortingData?.type
                                                  ? "rotate"
                                                  : ""
                                                  }`}
                                                onClick={() => {
                                                  sorting("role");
                                                }}
                                              />
                                            </th>
                                          </>
                                          : null
                                      }
                                      <th>
                                        Email
                                        <BsFilter
                                          className={`mx-2 j-cursor ${sortingData?.by == "email" &&
                                            sortingData?.type
                                            ? "rotate"
                                            : ""
                                            }`}
                                          onClick={() => {
                                            sorting("email");
                                          }}
                                        />
                                      </th>
                                      <th>
                                        Phone
                                        <BsFilter
                                          className={`mx-2 j-cursor ${sortingData?.by == "phoneNumber" &&
                                            sortingData?.type
                                            ? "rotate"
                                            : ""
                                            }`}
                                          onClick={() => {
                                            sorting("phoneNumber");
                                          }}
                                        />
                                      </th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {userDisplayList && userDisplayList.length > 0 ? (
                                      userDisplayList.map((user: User, index) => (
                                        <tr
                                          className={`${user.companyId !== currentUser.companyId
                                            ? ""
                                            : ""
                                            } border-bottom`}
                                          key={`${index}-${user.name}`}
                                        // onClick={() => {
                                        //   if (
                                        //     user.companyId !== currentUser.companyId
                                        //   )
                                        //     return;
                                        //   setShowUserProfile(true);
                                        //   setIsAddUser(false);
                                        //   setEditProfile(false);
                                        //   setSelectedUser(user);
                                        // }}
                                        >
                                          {/* <td style={{ width: "35px" }}>
                                        <div
                                          style={{
                                            backgroundColor: user.color
                                              ? `#${user.color}`
                                              : "#596de7",
                                          }}
                                          className={`${styles.profileImage}`}
                                        // style={{ backgroundColor: getRandomColor() }}
                                        >
                                          {renderName(user.name)}
                                        </div>
                                      </td> */}
                                          <td style={{ cursor: "" }}>
                                            <div className={styles.nameContainer}>
                                              <p className={styles.name}>
                                                {user.name}
                                              </p>
                                              <p className={styles.designation}>
                                                {user.designation}
                                              </p>
                                            </div>
                                          </td>
                                          {
                                            currentUser?.role != "Agency" ?
                                              <>
                                                <td style={{ maxWidth: "60px" }}>
                                                  {user?.companyName}
                                                </td>
                                                {/* <td style={{ maxWidth: "60px" }}>
                                                  <div
                                                    style={{
                                                      paddingLeft: user.designation
                                                        ? 0
                                                        : "1.5rem",
                                                    }}
                                                  >
                                                    {user.designation
                                                      ? user.designation
                                                      : "-"}
                                                  </div>
                                                </td> */}
                                                <td>
                                                  <select
                                                    name="role"
                                                    disabled={
                                                      currentUser?.companyId !==
                                                        user.companyId ||
                                                        user.id == currentUser?.id
                                                        ? true
                                                        : false
                                                    }
                                                    className={`form-select p-1 ${styles.selectBox}`}
                                                    style={{ maxWidth: "90px" }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                    }}
                                                    onChange={(e) => {
                                                      changeUserRole(e.target.value, user.id);
                                                    }}
                                                  >
                                                    {user?.role !== "Agency" ? (
                                                      <>
                                                        <option
                                                          value="Admin"
                                                          selected={user.role == "Admin"}
                                                        >
                                                          Admin
                                                        </option>
                                                        <option
                                                          value="User"
                                                          selected={user.role == "User"}
                                                        >
                                                          User
                                                        </option>
                                                      </>
                                                    ) : null}
                                                    {user.role !== "Admin" &&
                                                      user?.role !== UserRole.User ? (
                                                      <option
                                                        value="Agency"
                                                        selected={user.role == "Agency"}
                                                      >
                                                        Agency
                                                      </option>
                                                    ) : null}
                                                  </select>
                                                </td>
                                              </>
                                              : null
                                          }
                                          <td>{user.email}</td>
                                          <td>
                                            <div
                                              style={{
                                                paddingLeft: user.phoneNumber
                                                  ? 0
                                                  : "2rem",
                                              }}
                                            >
                                              {user.phoneNumber
                                                ? user.phoneCode + user.phoneNumber
                                                : "-"}
                                            </div>
                                          </td>
                                          <td>
                                            <div className={styles.tdActions}>
                                              <div
                                                style={{
                                                  cursor:
                                                    user.companyId ==
                                                      currentUser.companyId
                                                      ? "pointer"
                                                      : "not-allowed",
                                                }}
                                                className={`${styles.icon} ${styles.editButton
                                                  } ${user.companyId == currentUser.companyId
                                                    ? styles.iconhover
                                                    : ""
                                                  } me-2`}
                                                onClick={(e) => {
                                                  if (
                                                    user.companyId ==
                                                    currentUser.companyId
                                                  ) {
                                                    e.stopPropagation();
                                                    setSelectedUser(user);
                                                    editProfileToggle();
                                                  }
                                                }}
                                              >
                                                <MdOutlineEdit />
                                              </div>
                                              <div
                                                style={{
                                                  cursor:
                                                    getLocalUserId() != user.id.toString()
                                                      ? "pointer"
                                                      : "not-allowed",
                                                }}
                                                className={`${styles.icon} ${styles.editButton
                                                  } ${getLocalUserId() != user.id.toString()
                                                    ? styles.iconhover
                                                    : ""
                                                  }`}
                                                onClick={(e) => {
                                                  if (
                                                    getLocalUserId() != user.id.toString()
                                                  ) {
                                                    e.stopPropagation();
                                                    setSelectedUser(user);
                                                    toggle();
                                                  }
                                                }}
                                              >
                                                <BsTrash className={styles.delete} />
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr style={{ borderBottom: "none" }}>
                                        <td colSpan={7} className="text-center">
                                          <img src={NodataImage} alt="no-data" />
                                          <div className="text-center fs-4 p-2">
                                            No user found
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                                : <BrandTable
                                  userDisplayList={userDisplayList}
                                  activityStatus={activityStatus}
                                  setSelectedUser={setSelectedUser}
                                  toggle={toggle}
                                  setShowEllipsis={setShowEllipsis}
                                />
                            }
                          </div>
                        )}
                        {currentTab === "group" && (
                          <Table responsive borderless>
                            <thead className={styles.tableHeader}>
                              <tr>
                                <th>
                                  Name
                                  <BsFilter
                                    className={`mx-2 j-cursor ${groupSortingData?.by == "name" &&
                                      groupSortingData?.type
                                      ? "rotate"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      groupSorting("name");
                                    }}
                                  />
                                </th>
                                <th>No.of members</th>
                                <th>
                                  Owner
                                  <BsFilter
                                    className={`mx-2 j-cursor ${groupSortingData?.by == "username" &&
                                      groupSortingData?.type
                                      ? "rotate"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      groupSorting("username");
                                    }}
                                  />
                                </th>
                                <th>
                                  Created on
                                  <BsFilter
                                    className={`mx-2 j-cursor ${groupSortingData?.by == "createdAt" &&
                                      groupSortingData?.type
                                      ? "rotate"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      groupSorting("createdAt");
                                    }}
                                  />
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {userGroupData && userGroupData.length > 0 ? (
                                userGroupData?.map((group, index) => (
                                  <tr
                                    className="border-bottom j-cursor"
                                    key={index}
                                    onClick={() => {
                                      setIsViewGroup(true);
                                      setIsAddGroup(false);
                                      setSelectedUserGroup(group);
                                    }}
                                  >
                                    <td style={{ cursor: "pointer" }}>
                                      {group.name}
                                    </td>
                                    <td className={styles.memberList}>
                                      {group?.members?.length > 0 && (
                                        <div className="d-flex">
                                          {group.members
                                            ?.slice(0, 3)
                                            .map((e, index) => {
                                              return (
                                                <div
                                                  className="position-relative"
                                                  key={index}
                                                >
                                                  <span
                                                    style={{
                                                      backgroundColor: e.color
                                                        ? `#${e.color}`
                                                        : "#596de7",
                                                    }}
                                                    className={`${styles.profileIcon}`}
                                                  >
                                                    {renderName(e.name)}
                                                  </span>
                                                </div>
                                              );
                                            })}
                                          {group?.members?.length > 3 && (
                                            <div className="position-relative">
                                              <span
                                                className={`${styles.profileIcon} ${styles.light}`}
                                              >
                                                +{group?.members?.length - 3}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </td>
                                    <td>{group.username}</td>
                                    <td>{getTime(group.createdAt)}</td>
                                    <td>
                                      <div
                                        className={`${styles.icon} ${styles.border} ${styles.editButton}`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedUserGroup(group);
                                          toggle();
                                        }}
                                      >
                                        <BsTrash className={styles.delete} style={{ cursor: "pointer" }} />
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    <img src={NodataImage} alt="no-data" />
                                    <div className="text-center fs-4 p-2">
                                      No user groups found
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        )}
                        {pageData.totalRecord > 0 && pageData.totalPage > 0 && (
                          <div className="row">
                            <div className="col-12">
                              <div className={styles.pageNav}>
                                <MeritoButton
                                  type='secondary-1'
                                  size="md"
                                  onClick={() => {
                                    setPageData({
                                      ...pageData,
                                      currPage: pageData.currPage - 1,
                                    });
                                    getUserData({ ...pageData, currPage: pageData.currPage - 1, });
                                  }}
                                  onlyIcon={true}
                                  icon={<HiChevronLeft />}
                                  disabled={!(pageData.currPage !== 1)}
                                />
                                {Array.from(
                                  {
                                    length: Math.ceil(
                                      pageData.totalRecord / pageData.pageCount,
                                    ),
                                  },
                                  (_, i) => i + 1,
                                ).map((i) => (
                                  <MeritoButton
                                    type={pageData.currPage == i ? 'primary-1' : 'tertiary'}
                                    size="md"
                                    btnText={i}
                                    onClick={() => {
                                      setPageData({ ...pageData, currPage: i });
                                      getUserData({ ...pageData, currPage: i });
                                    }}
                                  />
                                ))}
                                <MeritoButton
                                  type='secondary-1'
                                  size="md"
                                  onClick={() => {
                                    setPageData({
                                      ...pageData,
                                      currPage: pageData.currPage + 1,
                                    })
                                    getUserData({ ...pageData, currPage: pageData.currPage + 1, });
                                  }}
                                  onlyIcon={true}
                                  icon={<HiChevronRight />}
                                  disabled={!(pageData.currPage !== pageData.totalPage)}
                                />
                                {/* {viewAll ?
                                                              <span className={`${styles.navItem} ${styles.viewAll}`} onClick={() => {
                                                                  let data = { currPage: 1, pageCount: initialPageData.pageCount }
                                                                  setPageData({ ...pageData, ...data });
                                                                  setViewAll(false)
                                                              }}>
                                                                  View Less
                                                              </span>
                                                              :
                                                              <span className={`${styles.navItem} ${styles.viewAll}`} onClick={() => {
                                                                  let data = { currPage: 1, pageCount: pageData.totalRecord }
                                                                  setPageData({ ...pageData, ...data });
                                                                  setViewAll(true)
                                                              }}>
                                                                  View All
                                                              </span>
                                                          } */}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
            }

            {currentTab === "user" &&
              (Boolean(isAddUser) ||
                Boolean(showUserProfile) ||
                Boolean(editProfile)) && (
                <div
                  className={`${styles.addUserBlock} demo_input_user_details`}
                >
                  <div className={styles.upperIcons}>
                    {!Boolean(isAddUser) && (
                      <div
                        className={`${styles.icon} ${styles.border}`}
                        onClick={() => {
                          setEditProfile(true);
                          setShowUserProfile(false);
                        }}
                      >
                        <MdOutlineEdit />
                      </div>
                    )}
                    {getLocalUserId() != selectedUser?.id?.toString() ? (
                      !Boolean(isAddUser) && (
                        <div
                          className={`${styles.icon} ${styles.border}`}
                          onClick={() => toggle()}
                        >
                          <BsTrash className={styles.delete} />
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                    <div
                      className={`${styles.icon}`}
                      onClick={() => {
                        setIsAddUser(false);
                        setShowUserProfile(false);
                        setEditProfile(false);
                      }}
                    >
                      <BsXLg />
                    </div>
                  </div>
                  {Boolean(isAddUser) && (
                    <AddUserForm
                      onClose={() => {
                        setIsAddUser(false);
                        getUserData();
                      }}
                    />
                  )}
                  {Boolean(showUserProfile) && (
                    <UserProfile
                      user={selectedUser}
                      edit={() => {
                        setEditProfile(true);
                        setShowUserProfile(false);
                        getUserData();
                      }}
                      allUsers={userDisplayList}
                    />
                  )}
                  {Boolean(editProfile) && (
                    <AddUserForm
                      user={selectedUser}
                      onClose={() => {
                        setEditProfile(false);
                        getUserData();
                      }}
                      isEdit={true}
                    />
                  )}
                </div>
              )}
            {currentTab === "group" &&
              (Boolean(isAddGroup) || Boolean(isViewGroup)) && (
                <div className={`${styles.addUserBlock}`}>
                  {!Boolean(isAddGroup) && (
                    <div className={styles.upperIcons}>
                      <div
                        className={`${styles.icon} ${styles.border}`}
                        onClick={() => {
                          toggle();
                        }}
                      >
                        <BsTrash className={styles.delete} />
                      </div>
                      <div
                        className={`${styles.icon}`}
                        onClick={() => {
                          setIsAddGroup(false);
                          setIsViewGroup(false);
                          getUserGroupData();
                        }}
                      >
                        <BsXLg />
                      </div>
                    </div>
                  )}
                  {Boolean(isAddGroup) && (
                    <AddGroupForm
                      onClose={() => {
                        setIsAddGroup(false);
                        getUserGroupData();
                      }}
                      toggle={() => {
                        setIsAddGroup(false);
                      }}
                    />
                  )}
                  {Boolean(isViewGroup) && (
                    <ViewGroup
                      userGroup={selectedUserGroup}
                      allUsers={selectedUserGroup.members}
                      onClose={() => {
                        setIsViewGroup(false);
                        getUserGroupData();
                      }}
                      updateData={getUserGroupData}
                    />
                  )}
                  {
                    // Boolean(showUserProfile) &&
                    // <UserProfile userName={selectedUser} edit={() => { setEditProfile(true); setShowUserProfile(false) }} />
                  }
                  {
                    // Boolean(editProfile) &&
                    // <AddUserForm userName={selectedUser} />
                  }
                </div>
              )}
          </div>
        </div >
      }

      <ConfirmDialog
        visible={visible}
        toggle={toggle}
        showCloseBtn={false}
        showButton={false}
        size='md'
        modalStyles={{
          width: '412px'
        }}
      // activeBtn={
      //   currentUser?.role !== "Agency" && selectedUser?.role !== "Agency"
      //     ? "Yes"
      //     : "Okay"
      // }
      // title={
      //   selectedUser?.role == "Agency"
      //     ? currentUser?.role != "Agency"
      //       ? "This agency will lose access to all your Workspaces"
      //       : "The agency will lose access to all Workspaces"
      //     : currentUser?.role == "Agency"
      //       ? "You will lose access to all their Workspaces"
      //       : "Are you sure you want to delete this user?"
      // }
      >
        <div className={styles.deleteDialog}>
          <div className={styles.body}>
            <BsFillExclamationCircleFill />
            {
              tab == TabRole.Team ?
                <>
                  <h2>Delete User?</h2>
                  <p><b>{selectedUser?.name}</b> will lose access to all brand data.</p>
                </> :
                <>
                  <h2>Remove Brand?</h2>
                  <p>Your agency will lose access to <b>{selectedUser?.companyName}’s</b> data.</p>
                </>
            }
          </div>
          <div className={styles.footer}>
            <MeritoButton
              type='secondary-2'
              size='md'
              btnText='Cancel'
              onClick={() => toggle()}
              isRounded={true}
            />
            <MeritoButton
              type='primary-1'
              size='md'
              btnText='Delete'
              onClick={() => {
                toggle()
                deleteConfirm()
              }}
              isRounded={true}
            />
          </div>
        </div>

      </ConfirmDialog >
      {
        selectedUser ? (
          <EditProfileModal
            visible={editProfileVisible}
            toggle={editProfileToggle}
            user={selectedUser}
            setSelectedUser={setSelectedUser}
            getUserData={getUserData}
          />
        ) : null
      }
      < NewUserModal
        getUserData={getUserData}
        visible={newUserVisible}
        toggle={newUserToggle}
      />

      <AddCustomerModal isOpen={addCustomerModalOpen} closeForm={() => setAddCustomerModalOpen(false)} />
    </>
  );
}
